
export const heightFromWidth = (originalH: number, originalW: number, targetW: number) =>
  (originalH / originalW) * targetW;

export const widthFromHeight = (originalH: number, originalW: number, targetH: number) =>
  (originalW / originalH) * targetH;